import { takeLatest } from 'redux-saga/effects';
import { GET_PRICING, UPDATE_THD_STORE_INFO } from '../../actions/actionTypes';
import safeSaga from '../safeSaga';
import getPricing from './getPricing';

const safeGetPricing = safeSaga(getPricing);

export default function* pricingSaga() {
  yield takeLatest(UPDATE_THD_STORE_INFO, safeGetPricing);
  yield takeLatest(GET_PRICING, safeGetPricing);
}
